import ShopHelper from './ShopHelper';

/**
 * Rounds a numeric value to two decimal places.
 * Returns the original value if it's not a number.
 */
export function roundOff(value) {
  if (typeof value !== 'number') return value;
  return Number(value.toFixed(2));
}

/**
 * Formats an amount with the shop's currency.
 * It fetches the currency via ShopHelper.getShopCurrency and rounds the amount.
 *
 * @param {number} amount - The monetary amount.
 * @param {object} shop - The shop object containing currency info.
 * @returns {string} Formatted string like "₹ 123.45"
 */
export function amountFormat(amount, shop) {
  const currency = ShopHelper.getShopCurrency(shop);
  const formatted = roundOff(amount);
  return `${currency} ${formatted}`;
}
